import { useState } from 'react'
import { Box } from '../imports/muiImport';

import { useNavigate } from 'react-router-dom';

import Signup from './authPages/Signup';
import OTPComponent from './otp/OTPComponent';
import Timer from '../pages/LOGIN_SIGNUP/OTP/Timer';
import { userTokenSave } from '../apiCalls/functions';
import { actionNotifier } from '../components/tostify';
import { useAuth } from '../hooks/contexts/AuthContext';
import { validateOtp } from '../apiCalls/urls/urlFunction';
import { verifyUserOTPForLogin } from '../mobile/mobileComponents/mobileUserAccountLogin/userAccoountHook';
import { getCampaignRedirectUrl, clearCampaignRedirectUrl } from '../shared/campaignTracker';

const SignupPage = () => {
  const [signupFormStep, setSignupFormStep] = useState({
    isShowUserPersonalDetailsForm: true,
    isShowOTPForm: false
  });

  const [isResendAvailable, setIsResendAvailable] = useState(false);
  const [otpFormLoading, setOtpFormLoading] = useState(false);
  const [isResetOtp, setIsResetOtp] = useState(false);
  const [isUserAuthentic, setIsUserAuthentic] = useState({});
  const [otpFormTimer, setOtpFormTimer] = useState(15);
  const [noOfUserOTPSend, setNoOfUserOTPSend] = useState(0);

  const [userCredentials, setUserCredentials] = useState({
    mobile: null,
    token: null,
    status: false,
    isLoginForm: true
  });

  const { authUser, setAuthUser, isLoggedIn, setIsLoggedIn } = useAuth();
  const navigate = useNavigate();


  const handleOtpVerify = async (user_phone, user_otp) => {
    setOtpFormLoading(true);
    const loginResponse = await verifyUserOTPForLogin(user_phone, user_otp);
    if (loginResponse?.status) {
      actionNotifier.success(loginResponse?.data?.message, { position: "top-left", autoClose: 2000 });

      const targetUrl = getCampaignRedirectUrl() || '/';

      if (loginResponse?.data?.data) {
        userLoginSuccessfully(loginResponse?.data?.data);
      }

      if (isUserAuthentic?.isLoginForm) {
        setTimeout(() => {
          clearCampaignRedirectUrl();
          navigate(targetUrl, { replace: true });
          setOtpFormLoading(false);
        }, 300);
      } else {
        setTimeout(() => {
          if (loginResponse?.data?.data) {
            clearCampaignRedirectUrl();
            navigate(targetUrl, { replace: true });
          } else {
            navigate('/login', { replace: true });
          }
          setOtpFormLoading(false);
          setIsResetOtp(true);
        }, 300);
      }
    } else {
      setOtpFormLoading(false);
      setIsResetOtp(true);
    }
  }

  const handleOtpResend = async (mobile) => {
    if (isResendAvailable) {
      const response = await validateOtp(mobile,
        {
          'reason': "Signup_resend"
        });
      if (response?.status) {
        setNoOfUserOTPSend((prevState) => prevState + 1);
        setOtpFormTimer(() => 15);

        actionNotifier.info("OTP has been resent", { position: "top-left", autoClose: 1000 });
      }
    } else {
      actionNotifier.warning(`Please wait for the timer to resend OTP`, { position: "top-left", autoClose: 1000 });
    }
  }

  const userLoginSuccessfully = (token) => {
    let loginToken = userTokenSave(token);

    if (loginToken) {
      // Set true User Login Status it will reflect every where
      setIsLoggedIn(true);

      // Notification remove
      actionNotifier.clearAll();
      const targetUrl = getCampaignRedirectUrl() || '/';
      clearCampaignRedirectUrl();
      navigate(targetUrl, { replace: true });
    }
  }


  const handleUserForm = (key) => {
    setSignupFormStep((prevState) => {
      switch (key) {
        case "USERREGISTERFORMFILLSUCCESSFUL":
          return {
            ...prevState,
            isShowUserPersonalDetailsForm: false,
            isShowOTPForm: true
          };
        default:
          return {
            isShowUserPersonalDetailsForm: true,
            isShowOTPForm: false
          };
      }
    });
  };

  const timerEnd = () => {
    if (noOfUserOTPSend <= 2) {
      setIsResendAvailable(() => true);
      setOtpFormTimer(() => null);
      setOtpFormLoading(false);
    } else {
      setOtpFormLoading(false);
      setIsResetOtp(true);
      setIsResendAvailable(() => false);
      window.location.reload();
    }
  }

  return (
    <>
      {signupFormStep?.isShowUserPersonalDetailsForm &&
        (
          <Signup
            setIsUserAuthentic={setIsUserAuthentic}
            handleUserForm={handleUserForm}
          />
        )
      }

      {signupFormStep?.isShowOTPForm &&
        (
          <>
            <OTPComponent
              phone={isUserAuthentic?.mobile}
              purpose="Sign up OTP"
              loading={otpFormLoading}
              isResendAvailable={isResendAvailable}
              onVerifyOtp={handleOtpVerify}
              onResendOtp={handleOtpResend}
              isResetOtp={isResetOtp}
              className={'signup-verify-otp'}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",

              }}
            >
              <Timer
                initialTime={otpFormTimer}
                timeEnd={timerEnd}
                timerStyle={{}}
              />
            </Box>
          </>
        )
      }
    </>
  )
}

export default SignupPage
